import React, { ReactElement, useState } from 'react';
import { Heading, Loader } from 'idsk-react-components';
import './VybranePredpisy.scss';
import { Message } from 'slovlex-idsk-react-components';
import BoxList from '../../../BoxList/BoxList';
import { useClient } from '../../../../context/ClientStatusContext';
import { getVybranePredpisyList } from '../../../../client/vybranePredpisyClient';

const VybranePredpisyBoxListComponent = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getVybranePredpisyList(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Loader loading={status.loading}>
      <div className="vybrane-predpisy">
        <Heading size="l">Vybrané predpisy</Heading>
        {(status.responseCode && status.responseCode > 399)
          ? (
            <>
              {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať vybrané predpisy.
              </Message>
              )}
            </>
          )
          : (
            <>
              {data
                && (
                  <BoxList dataList={data} />
                )}
            </>
          )}
      </div>
    </Loader>
  );
};

export default VybranePredpisyBoxListComponent;
